import { useCallback, useEffect, useState } from 'react'
import message from 'antd/lib/message'
import { loadStripe } from '@stripe/stripe-js'
import { useHistory } from 'react-router-dom'
import config from 'config'
import { analytics, apiManager, constants } from 'helpers'

const {
  ROUTES: { TICKETS },
  EVENT_CONSTANTS,
} = constants

const {
  TICKETS: { NEW_EVENT_PARAMS_KEY },
} = EVENT_CONSTANTS

const useEventSignUp = () => {
  const history = useHistory()
  const [stripe, setStripe] = useState()

  useEffect(() => {
    loadStripe(config.stripe.public_key).then(setStripe)
  }, [])

  const signupForEvent = useCallback(
    async ({ id, title, ticketPrice }, { onSuccess = onSignupSuccess } = {}) => {
      analytics.segmentTrack('User Clicked Reserve Button', {
        eventId: id,
      })
      message.loading('Reserving ticket...')
      try {
        const { sessionId } = await apiManager.signupForEvent({
          eventId: id,
          firstPromoterId: window.FPROM?.data?.tid,
        })
        if (sessionId) {
          analytics.segmentTrack('Payment Process Started', {
            event_id: id,
            event_name: title,
            amount: ticketPrice,
            payment_method: 'Stripe',
            currency: 'USD',
          })
          const result = await stripe?.redirectToCheckout({ sessionId })
          if (result?.error?.message) {
            throw new Error(result.error.message)
          }
        } else {
          message.destroy()
          onSuccess(id, history)
        }
      } catch (err) {
        message.error(err.message)
      }
    },
    [history, stripe]
  )

  return signupForEvent
}

const onSignupSuccess = (id, history) => history.push(`${TICKETS}?${NEW_EVENT_PARAMS_KEY}=${id}`)

export default useEventSignUp
